import session from 'models/sessionInstance'
import MetadataMMOView from 'views/agents/metadata/MMOView'
import MetadataTwitterView from 'views/agents/metadata/TwitterView'
import MetadataFacebookView from 'views/agents/metadata/FacebookView'
import MetadataYoutubeView from 'views/agents/metadata/YoutubeView'
import MetadataDefaultView from 'views/agents/metadata/DefaultView'
import MetadataEMMView from 'views/agents/metadata/EmmView'
import MetadataInstagramView from 'views/agents/metadata/InstagramView'
import MetadataGooglePlusView from 'views/agents/metadata/GooglePlusView'
import MetadataImportedView from 'views/agents/metadata/ImportedView'
import MetadataDpaView from 'views/agents/metadata/DpaView'
import MetadataCuriaView from 'views/agents/metadata/CuriaView'

export default function (agentResult, options = {}) {
  if (agentResult.isDpaClip()) {
    return (new MetadataDpaView({ agentResult: agentResult }))
  } else if (agentResult.isMMOClip()) {
    return (new MetadataMMOView({ agentResult: agentResult }));
  } else  if (agentResult.isTwitterClip()) {
    return (new MetadataTwitterView({ agentResult: agentResult }));
  } else  if (agentResult.isFacebookClip()) {
    return (new MetadataFacebookView({ agentResult: agentResult }));
  } else  if (agentResult.isYoutubeClip()) {
    return (new MetadataYoutubeView({ agentResult: agentResult }));
  } else if (agentResult.isRtvClip()) {
    return (new MetadataEMMView({ agentResult: agentResult }));
  } else if (agentResult.isInstagramClip()) {
    return (new MetadataInstagramView({ agentResult: agentResult }));
  } else if (agentResult.isGooglePlusClip()) {
    return (new MetadataGooglePlusView({ agentResult: agentResult }));
  } else if (agentResult.isImportedClip()) {
    return (new MetadataImportedView({ agentResult: agentResult, userCountry: session.get('country') }))
  } else if (agentResult.isCuriaClip()) {
    return (new MetadataCuriaView({ agentResult: agentResult }))
  } else {
    return (new MetadataDefaultView({ agentResult: agentResult, userCountry: session.get('country') }));
  }
}
